module.exports = " \n<app-tnhomeslider></app-tnhomeslider>                  \n<app-tnsearchpanel></app-tnsearchpanel> \n<tn-ads-list></tn-ads-list> \n<tn-home-desc></tn-home-desc>\n<tn-facebook-widget></tn-facebook-widget>\n<!-- <tn-news-list in-home=\"true\"></tn-news-list> -->"


//////////////////
// WEBPACK FOOTER
// A:/Work/Siti/Volpe2/src/app/themes/default/html/home.component.html
// module id = ../../../../../src/app/themes/default/html/home.component.html
// module chunks = 1